<div class="progress-header">
  @if (accountHat) {
    <p class="c11n-text-sm progress-header__account-hat">{{ accountHat }}</p>
  }
  <div class="progress-header__top-row">
    <span class="c11n-text-sm-bold">{{ labelText }}</span>
    <app-cancel quitButtonVariant="ghost" [isTransparent]="true"></app-cancel>
  </div>
  <c11n-progress-bar
    [value]="value" [maxValue]="maxValue" [labelText]="labelText" [hideLabel]="true">
  </c11n-progress-bar>
</div>
